import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import Header from "./components/Header";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import ServiceInfos from "./pages/ServiceInfos";
import About from "./pages/About";

const GlobalStyle = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html {
    scroll-behavior: smooth;
  }
  body{
    font-family: 'Fira Sans', 'Poppins', 'Oxygen', 'Cantarell', sans-serif; 
    font-size: 1rem;
    font-weight: 500;
    color: #222;
    background: ${"#f8f9fa"};
    line-height: 1.6;
  }
  img {
    display: block;
    max-width: 100%;
  }
  button,
  input,
  textarea {
    font: inherit;
  }
`;

function App() {
  return (
    <Router>
      <Header />
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contacts" element={<Contact />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Apropos" element={<About />} />
        <Route path="/Services/:title" element={<ServiceInfos />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
